import { render, staticRenderFns } from "./wasteUCManage.vue?vue&type=template&id=095fe882"
import script from "./wasteUCManage.vue?vue&type=script&lang=js"
export * from "./wasteUCManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095fe882')) {
      api.createRecord('095fe882', component.options)
    } else {
      api.reload('095fe882', component.options)
    }
    module.hot.accept("./wasteUCManage.vue?vue&type=template&id=095fe882", function () {
      api.rerender('095fe882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/waste/wasteUCManage.vue"
export default component.exports